import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {
  ModalController,
  IonAvatar,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonTitle,
  IonToolbar,
} from '@ionic/angular';
import {ApiService} from "../../services/api/api.service";

export type Team = { id: number; name: string; logo: string };

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-team-picker-modal',
  templateUrl: './team-picker-modal.component.html',
  styleUrls: ['./team-picker-modal.component.scss'],
  standalone: true,
  imports: [
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    IonIcon,
    IonTitle,
    IonContent,
    IonList,
    IonItem,
    IonLabel,
    IonAvatar
  ]
})
export class TeamPickerModalComponent {
  @Input() selectedId: number | null = null;
  teams: Team[] = [];

  constructor(
    private modalCtrl: ModalController,
    public api: ApiService,
    ) {
    this.api.getMyTeamList().subscribe(res => {
      console.log('getMyTeamInfo', res.data);
      console.log(res.data);
      this.teams = res.data;
    });
  }

  close() {
    this.modalCtrl.dismiss();
  }

  pick(team: Team) {
    (document.activeElement as HTMLElement | null)?.blur?.();
    queueMicrotask(() => this.modalCtrl.dismiss({ team }));
  }

}
